var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "uk-button uk-button-text",
    on: {
      "click": _vm.logoutWhenConfirmed
    }
  }, [_c('icon', {
    staticClass: "uk-margin-small-right",
    attrs: {
      "name": "sign-out"
    }
  }), _vm._v("\n    Logout\n")], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-108d99d7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LogoutButton.vue
// module id = 1859
// module chunks = 0